import styled from "styled-components";

export const PricingTableContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: end;
    padding: 40px 0;
    width: 100%;
    transition: 0.2s;
    @media screen and (max-width: 767px){
        flex-direction: column;
        align-items: center;
        padding: 40px 20px;
    }
`;